import { render, staticRenderFns } from "./RatingTable.vue?vue&type=template&id=ec5717e2&"
import script from "./RatingTable.vue?vue&type=script&lang=js&"
export * from "./RatingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports